import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Footer } from "../components/Footer";
import Typography from '@mui/material/Typography'
import { GlobalStyles, Paper } from "@mui/material";
import { useContext  } from "react";
import { AppContext } from "../context";
import React from "react";
import { Trophy } from "../images/trophy";


export const PyamentAproved = () => {
  const { theme, logo, contact, finalSentence } =  useContext<any>(AppContext);


    return (
      <>
      <Container component="main" maxWidth="md">
      <GlobalStyles
      styles={{
        body: { 
        backgroundColor: `white`}
      }}
      />
        <Paper 
        variant="outlined" 
        elevation={0}
        sx={{
          my: 3,
          // backgroundColor: `#dcdcdc`,
          display: 'flex',
          flexDirection: 'column',
          height: '90vh',
          justifyContent: 'space-evenly',
         }}
        >
          <img src={logo} alt=""  style={{margin: '0 auto', width: '250px'}}/>
          <Typography
           sx={{color: 'primary.main', fontSize: '2.4rem', px: 1, fontWeight: 'bold'}}
           align='center'>
         Pagamento realizado com sucesso!
          </Typography>
          <Box sx={{mx: 'auto'}}>
          <Trophy />
          </Box>
          <Box>
          <Typography
           sx={{color: 'primary.main', fontSize: '1.5rem', px: 1, mb: 3}}
           align='center'>
             <strong>Enviamos para seu email informações sobre seus benefícios!</strong>
          </Typography>
          {finalSentence ? 
          <Typography
          sx={{color: 'primary.main', fontSize: '1.5rem', px: 1}}
          align='center'>
            {finalSentence}{" "}
           Em caso de dúvida entre em contato: {contact ? contact : 'atendimento@briasaude.com' }
         </Typography>
         :
         <Typography
           sx={{color: 'primary.main', fontSize: '1.5rem', px: 1}}
           align='center'>
             Em até 48h seus benefícios serão ativados. 
            Em caso de dúvida entre em contato: {contact ? contact : 'atendimento@briasaude.com' }
          </Typography>}
          </Box>
          <Box sx={{width:'100wv',
                  alignItems: "center"}}>
        <Footer />
        </Box>
        </Paper>
       
      </Container>
      </>
    )
}